import Vue from 'vue';
import Vuelidate from 'vuelidate';
import vuelidateErrorExtractor from 'vuelidate-error-extractor';
import FormGroup from './FormGroup.vue';

Vue.use(Vuelidate);
Vue.use(vuelidateErrorExtractor, {
  template: FormGroup,
});
